import { Navigate } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";
import { LoadingPage } from "@/components/ui/loading-page";

interface MainAdminRouteProps {
  children: React.ReactNode;
}

/** Email Management is restricted to main administrators (adminType === "ADMIN"). */
export function MainAdminRoute({ children }: MainAdminRouteProps) {
  const { adminType, loading } = usePermissions();

  if (loading) {
    return <LoadingPage message="Checking access..." />;
  }

  if (adminType !== "ADMIN") {
    return <Navigate to="/forbidden" replace />;
  }

  return <>{children}</>;
}
